import { setErrorMessage, setSuccessModal } from "./appActions";
import { billing } from "store/requests";

export const encounterCheckIn = (payload) => {
  return async (dispatch, store) => {
    try {
      let response = await billing({
        url: "/encounterCheckIn",
        payload,
      });
      const charge_entry_id = response?.data?.charge_entry_id;
      dispatch(
        setSuccessModal({
          open: true,
          title: "Charge Entry Created Successfully",
          message: charge_entry_id ? `Charge Entry Id: ${charge_entry_id}` : "",
        }),
      );
      return response;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getEncounterCharges = (payload) => {
  return async (dispatch, store) => {
    try {
      let response = await billing({
        url: "/getEncounterCharges",
        payload,
      });
      return response.data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getEncounterList = async (payload) => {
  try {
    let response = await billing({
      url: "/getEncounterList",
      payload,
    });

    let a = [];
    let b = [];
    let c = [];
    for (let p of response.data) {
      if (p.charge_entry_id && p.dictation_id) c.push(p);
      else if (p.charge_entry_id) b.push(p);
      else a.push(p);
    }
    a.sort((x, y) => {
      if (x.first_name < y.first_name) {
        return -1;
      }
      if (x.first_name > y.first_name) {
        return 1;
      }
      return 0;
    });
    const encounterList = a.concat(b, c);
    return encounterList;
  } catch (error) {
    console.log(error);
  }
};

export const getEncounterInsEligList = async (payload) => {
  try {
    let response = await billing({
      url: "/getEncounterInsEligList",
      payload,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
